import createFullContext from "../../common/utils/createFullContext";

type SheetContext = {
    isSheetPresent: boolean;
    setSheetPresent: (value: boolean | ((prev: boolean) => boolean)) => void;
    id: string;
};

export const [SheetProvider, useSheetContext] = createFullContext<SheetContext>(
    "Sheet component not found in the tree",
);
